// @ts-check
import { Body1 } from '@linearb/linui-common/typography';
import { MarketplaceIcon, lightColorPalette } from '@linearb/linui-common';
import { Tooltip } from '@material-ui/core';
import { Stack } from '@mui/material';
import { TagWrapper } from './base/layout-components';
import Text from './base/Text';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import styled from 'styled-components';
import AppRouter from 'common/AppRouter';
import { once } from 'lodash';
import GuyOnComputer from 'images/characters/guy-on-computer.svg';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { LBButton } from '@linearb/buzz';

const StyledSVG = styled.img`
  width: 18rem;
  height: 18rem;
`;

const StyledGitStreamCTABadge = styled.div`
  ${({ position }) =>
    position === 'bottom'
      ? `position: absolute;
        right: 3rem;
        top: 6rem;`
      : `margin-left: 1px;`}
`;

const tooltipContent = (title, linkToMarketplace) => (
  <Stack direction='column' padding={1.5} paddingTop={0} maxWidth='20rem'>
    <StyledSVG src={GuyOnComputer} alt='' />
    <Body1 bold color={lightColorPalette.lbTextSubdued}>
      Your PR {title} is high
    </Body1>
    <Body1
      color={lightColorPalette.lbTextSubdued}
      paddingTop={2}
      paddingBottom={4}
    >
      Try SEI Automations to help
      <br />
      speed up your team's workflow!
    </Body1>
    <Stack alignItems='center' paddingBottom={1}>
      <LBButton
        size='sm'
        asChild
        onClick={() => {
          TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
            page: window.location.pathname,
            click_type: TRACKING.CLICK.CHECK_GIT_STREAM_BUTTON,
            value: `${title.toUpperCase()}`
          });
        }}
      >
        <a {...linkToMarketplace}>
          <MarketplaceIcon size={16} /> Marketplace
        </a>
      </LBButton>
    </Stack>
  </Stack>
);

const GitStreamCTABadgeWithTooltip = ({
  title,
  gitStreamBadgeContent,
  position
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const enableMarketplace = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.automationsMarketplaceViewEnable
  });

  const linkToMarketplace = enableMarketplace
    ? {
        href: AppRouter.MARKETPLACE.path
      }
    : {
        href: 'https://docs.gitstream.cm',
        target: '_blank'
      };

  return (
    <Tooltip
      interactive
      placement='bottom-start'
      title={tooltipContent(title, linkToMarketplace)}
      onOpen={once(() => {
        TrackingService.logEvent(TRACKING.EVENTS.HOVER, {
          page: window.location.pathname,
          hover_type: TRACKING.HOVER.HELP_ME_IMPROVE_GIT_STREAM_CTA,
          value: `${title.toUpperCase()}`
        });
      })}
    >
      <StyledGitStreamCTABadge
        data-testid='gitStreamCTABadge'
        position={position}
      >
        <TagWrapper
          backgroundColor='zircon'
          borderColor='botticelli'
          mt='small'
        >
          <Text
            ellipsisAfter='10rem'
            weight='400'
            color='shuttleGray'
            cursor='pointer'
          >
            {gitStreamBadgeContent}
          </Text>
        </TagWrapper>
      </StyledGitStreamCTABadge>
    </Tooltip>
  );
};

export default GitStreamCTABadgeWithTooltip;
